import { FC } from 'react';

import { StockLevelStatuses } from '@telialt/models/src/EshopModel';
import { selectProductStock } from '@telialt/utils/src/eshopSelectors';

import { useCartQuery } from '../hooks/queries/useCartQuery';
import { OutOfStockStatus } from './OutOfStockStatus';
import { ProductPreOrderStockStatus } from './ProductPreOrderStockStatus';

export const ProductStockStatus: FC = () => {
    const { cart } = useCartQuery();
    const stock = selectProductStock(cart);
    if (!stock) {
        return null;
    }

    const isPreOrder = stock?.stockLevelStatus === StockLevelStatuses.FutureStock;
    const isOutOfStock = stock?.stockLevelStatus === StockLevelStatuses.NoStock;

    if (isPreOrder) {
        return <ProductPreOrderStockStatus stock={stock} />;
    }

    if (isOutOfStock) {
        return <OutOfStockStatus stock={stock} />;
    }

    return null;
};
